import { useParams } from 'react-router-dom';
import FamilyTree from './FamilyTree';
import { parseHybridSlug } from '../../utils/treeUrl';

/* ──────────────────────────────────────────
   Public branch tree — chromeless, shareable
   canvas for a single branch, accessible
   without authentication.
   ────────────────────────────────────────── */
export default function PublicBranchTree() {
  const { branchSlug } = useParams();
  const branchId = parseHybridSlug(branchSlug);

  return <FamilyTree publicView branchId={branchId} />;
}
